export const validateLinkedinProfileUrl = (url: string | undefined) => {
    return url === undefined
        ? false
        : new RegExp(/^(http(s)?:\/\/)?(\w\w\w\.)?linkedin\.com\/(in)\/.+/).test(url);
};
